(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vp-cart-tax-id"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('vp-cart-tax-id')) {
    customElements.define(
      'vp-cart-tax-id',
      class VpCartTaxId extends HTMLElement {
        constructor() {
          super();
          this.saveQueue = Promise.resolve();
          this.onFormSubmit = this.onFormSubmit.bind(this);
          this.onCheckoutClick = this.onCheckoutClick.bind(this);

          this.addEventListener('change', (event) => {
            if (event.target.matches('[data-vp-tax-choice]')) this.handleChoice();
            if (event.target.matches('[data-vp-tax-input]')) this.handleInput();
          });

          this.addEventListener(
            'input',
            debounce((event) => {
              if (event.target.matches('[data-vp-tax-input]')) this.handleInput();
            }, 300)
          );
        }

        connectedCallback() {
          const form = document.getElementById(this.dataset.formId);
          if (form) form.addEventListener('submit', this.onFormSubmit);

          this.checkoutButtons().forEach((button) => {
            button.addEventListener('click', this.onCheckoutClick, true);
          });
        }

        disconnectedCallback() {
          const form = document.getElementById(this.dataset.formId);
          if (form) form.removeEventListener('submit', this.onFormSubmit);

          this.checkoutButtons().forEach((button) => {
            button.removeEventListener('click', this.onCheckoutClick, true);
          });
        }

        checkoutButtons() {
          const buttons = [];
          document.querySelectorAll('[name="checkout"]').forEach((button) => {
            const formId = button.getAttribute('form') || (button.closest('form') && button.closest('form').id);
            if (formId === this.dataset.formId) buttons.push(button);
          });

          if (this.dataset.formId === 'cart') {
            document.querySelectorAll('.additional-checkout-buttons').forEach((node) => buttons.push(node));
          }

          return buttons;
        }

        selectedChoice() {
          const selected = this.querySelector('[data-vp-tax-choice]:checked');
          return selected ? selected.value : '';
        }

        taxValue() {
          const input = this.querySelector('[data-vp-tax-input]');
          return input ? input.value.trim() : '';
        }

        validationMessage() {
          const choice = this.selectedChoice();
          if (!choice) return this.dataset.requiredAlert || '';
          if (choice === 'yes' && !this.taxValue()) return this.dataset.taxAlert || '';
          return '';
        }

        showAlert(message) {
          const alertNode = this.querySelector('[data-vp-tax-alert]');
          if (!alertNode) return;
          if (!message) {
            alertNode.hidden = true;
            alertNode.textContent = '';
            return;
          }
          alertNode.textContent = message;
          alertNode.hidden = false;
          alertNode.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }

        handleChoice() {
          const choice = this.selectedChoice();
          const field = this.querySelector('[data-vp-tax-field]');
          const input = this.querySelector('[data-vp-tax-input]');
          if (!field || !input) return;

          this.showAlert('');

          if (choice === 'yes') {
            field.hidden = false;
            input.disabled = false;
            input.focus();
            return;
          }

          field.hidden = true;
          input.disabled = true;
          input.value = '';
          if (choice === 'no') this.enqueueSave(this.dataset.noValue || 'No');
        }

        handleInput() {
          if (this.selectedChoice() !== 'yes') return;
          const value = this.taxValue();
          if (value) this.showAlert('');
          this.enqueueSave(value);
        }

        onCheckoutClick(event) {
          if (this.isFlushing) return;
          const message = this.validationMessage();
          if (!message) return;
          event.preventDefault();
          event.stopPropagation();
          this.showAlert(message);
        }

        async onFormSubmit(event) {
          if (this.isFlushing) return;

          const message = this.validationMessage();
          if (message) {
            event.preventDefault();
            this.showAlert(message);
            return;
          }

          const choice = this.selectedChoice();
          const value = choice === 'yes' ? this.taxValue() : this.dataset.noValue || 'No';

          event.preventDefault();
          this.isFlushing = true;
          try {
            await this.enqueueSave(value);
          } finally {
            if (!event.target.querySelector('input[name="checkout"]')) {
              const checkoutInput = document.createElement('input');
              checkoutInput.type = 'hidden';
              checkoutInput.name = 'checkout';
              checkoutInput.value = '';
              event.target.appendChild(checkoutInput);
            }
            event.target.submit();
          }
        }

        enqueueSave(value) {
          this.saveQueue = this.saveQueue
            .then(() => this.persistTaxId(value))
            .catch(() => {});
          return this.saveQueue;
        }

        async persistTaxId(value) {
          const key = this.dataset.propertyKey;
          if (!key) return;

          await this.saveCartAttribute(key, value);
          await this.saveLineProperties(key, value);
        }

        saveCartAttribute(key, value) {
          if (!window.routes || !window.routes.cart_update_url) return Promise.resolve();

          let attributes = {};
          try {
            attributes = JSON.parse(this.dataset.cartAttributes || '{}');
          } catch (error) {
            attributes = {};
          }

          attributes[key] = value;

          return fetch(`${window.routes.cart_update_url}`, {
            ...fetchConfig(),
            body: JSON.stringify({ attributes }),
          });
        }

        async saveLineProperties(key, value) {
          if (!window.routes || !window.routes.cart_change_url) return;

          const cart = await fetch(`${window.routes.cart_url}.js`).then((response) => response.json());
          if (!cart.items || !cart.items.length) return;

          for (const item of cart.items) {
            const properties = Object.assign({}, item.properties || {});
            const current = properties[key] ? String(properties[key]) : '';

            if (value) {
              if (current === value) continue;
              properties[key] = value;
            } else {
              if (!Object.prototype.hasOwnProperty.call(properties, key)) continue;
              delete properties[key];
            }

            await fetch(`${window.routes.cart_change_url}`, {
              ...fetchConfig(),
              body: JSON.stringify({
                id: item.key,
                quantity: item.quantity,
                properties,
              }),
            });
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
